<editor
  #tinyEditor
  [init]="init"
  [initialValue]="content"
  (onMouseDown)="onMouseDown($event)"
  (onFocusOut)="onFocusOut()"
/>
